

<div id="overlay">
  <!-- This button triggers the overlay and is it's origin -->
  <button class="float-right" mat-stroked-button (click)="isOpen = !isOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <mat-icon inline="true">filter_list</mat-icon> {{isOpen ? "Filters" : "Filters"}}
  </button>
  <button  *ngIf="appService.isFilterApplied" class="float-left reset-button" mat-stroked-button type="button" (click)="clearAllFilter()">Reset
  </button>

  <!-- This template displays the overlay content and is connected to the button -->
<ng-template cdkConnectedOverlay (backdropClick)="isOpen = !isOpen"
[cdkConnectedOverlayHasBackdrop]="isOpen"
              [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop-cs'"
[cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen">
<mat-accordion class="filter-content">
  <form [formGroup]="customFilterForm">
  <div class="custom-filter">
    <h1 class="filter-title">Filters</h1>
    <div class="row filter-container">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="filter-title">Brand </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="segment-class segment-mat-card-style segment-list-text">
            <!-- <mat-card-title>Brands</mat-card-title> -->
            <mat-radio-group (change)= "onBrandSelected($event, brandSegment.selectedOptions.selected)" formControlName="brandOperator" class="filter-radio-button" aria-label="Select an option">
              <mat-radio-button value="is equal to">equals</mat-radio-button>
              <mat-radio-button value="is not equal to">not equals</mat-radio-button>
            </mat-radio-group>
            <mat-selection-list class="list-horizontal" #brandSegment  formControlName="brandCriteria"
              (selectionChange)="onBrandSelected($event, brandSegment.selectedOptions.selected)">
              <mat-list-option *ngFor="let brand of brands" [value]="brand.id" checkboxPosition="before"
                id="{{brand.id}}" style="font-size: inherit;">
                {{brand.name}}
              </mat-list-option>
            </mat-selection-list>
          </mat-card>
        </mat-expansion-panel>

    </div>

    <div class="row filter-container">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="filter-title">Product </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="segment-class segment-mat-card-style segment-list-text">
            <mat-radio-group (change)="onProductSelected($event, productSegment.selectedOptions.selected)" formControlName="productOperator" class="filter-radio-button" aria-label="Select an option">
              <mat-radio-button value="is equal to">equals</mat-radio-button>
              <mat-radio-button value="is not equal to">not equals</mat-radio-button>
            </mat-radio-group>
            <mat-selection-list #productSegment formControlName="productCriteria"
              (selectionChange)="onProductSelected($event, productSegment.selectedOptions.selected)">
              <mat-list-option *ngFor="let product of filteredProductsByBrand" [value]="product.code"
                checkboxPosition="before" id="{{product.productUID}}" style="font-size: inherit;">
                {{product.code}} - {{product.name}}
              </mat-list-option>
            </mat-selection-list>
          </mat-card>
        </mat-expansion-panel>

    </div>

    <div class="row filter-container">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="filter-title">Branch </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="segment-class segment-mat-card-style segment-list-text">
            <mat-radio-group (change)="onBranchSelected(branchSegment.selectedOptions.selected)" formControlName="branchOperator" class="filter-radio-button" aria-label="Select an option">
              <mat-radio-button value="is equal to">equals</mat-radio-button>
              <mat-radio-button value="is not equal to">not equals</mat-radio-button>
            </mat-radio-group>
            <mat-selection-list #branchSegment (selectionChange)="onBranchSelected(branchSegment.selectedOptions.selected)" formControlName="branchCriteria">
              <mat-list-option *ngFor="let branch of branchList" [value]="branch.value"
                checkboxPosition="before" id="{{branch.value}}" style="font-size: inherit;">
                {{branch.displayText}}
              </mat-list-option>
            </mat-selection-list>
          </mat-card>
        </mat-expansion-panel>

    </div>

    <div class="row filter-container">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="filter-title">Application Status </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="segment-class segment-mat-card-style segment-list-text">
            <mat-radio-group (change)="onApplicationSelected(applicationSegment.selectedOptions.selected)" formControlName="applicationOperator" class="filter-radio-button" aria-label="Select an option">
              <mat-radio-button value="is equal to">equals</mat-radio-button>
              <mat-radio-button value="is not equal to">not equals</mat-radio-button>
            </mat-radio-group>
            <mat-selection-list #applicationSegment (selectionChange)="onApplicationSelected(applicationSegment.selectedOptions.selected)" formControlName="applicationCriteria">
              <mat-list-option *ngFor="let status of applicationStatus" [value]="status.value"
                checkboxPosition="before" id="{{status.value}}" style="font-size: inherit;">
                {{status.displayText}}
              </mat-list-option>
            </mat-selection-list>
          </mat-card>
        </mat-expansion-panel>

    </div>

    <div class="row filter-container">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="filter-title">Channel </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="segment-class segment-mat-card-style segment-list-text">
            <mat-radio-group (change)="onChannelSelected(ChannelSegment.selectedOptions.selected)" formControlName="channelOperator" class="filter-radio-button" aria-label="Select an option">
              <mat-radio-button value="is equal to">equals</mat-radio-button>
              <mat-radio-button value="is not equal to">not equals</mat-radio-button>
            </mat-radio-group>
            <mat-selection-list #ChannelSegment (selectionChange)="onChannelSelected(ChannelSegment.selectedOptions.selected)" formControlName="channelCriteria">
              <mat-list-option *ngFor="let channel of channels" [value]="channel.value"
                checkboxPosition="before" id="{{channel.value}}" style="font-size: inherit;">
                {{channel.displayText}}
              </mat-list-option>
            </mat-selection-list>
          </mat-card>
        </mat-expansion-panel>

    </div>

    <div class="row filter-container">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="filter-title">Ownership </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="segment-class segment-mat-card-style segment-list-text">
            <mat-radio-group (change)="onOwnershipSelected(OwnershipSegment.selectedOptions.selected)" formControlName="ownershipOperator" class="filter-radio-button" aria-label="Select an option">
              <mat-radio-button value="is equal to">equals</mat-radio-button>
              <mat-radio-button value="is not equal to">not equals</mat-radio-button>
            </mat-radio-group>
            <mat-selection-list #OwnershipSegment (selectionChange)="onOwnershipSelected(OwnershipSegment.selectedOptions.selected)" formControlName="ownershipCriteria">
              <mat-list-option *ngFor="let ownership of ownerships" [value]="ownership.value"
                checkboxPosition="before" id="{{ownership.value}}" style="font-size: inherit;">
                {{ownership.displayText}}
              </mat-list-option>
            </mat-selection-list>
          </mat-card>
        </mat-expansion-panel>

    </div>

    <div class="row filter-container">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="filter-title">Reference Code </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="segment-class segment-mat-card-style segment-list-text">
            <mat-radio-group (change)="onReferenceSelected(ReferenceSegment.selectedOptions.selected)" formControlName="referenceOperator" class="filter-radio-button" aria-label="Select an option">
              <mat-radio-button value="is equal to">equals</mat-radio-button>
              <mat-radio-button value="is not equal to">not equals</mat-radio-button>
            </mat-radio-group>
            <mat-selection-list #ReferenceSegment (selectionChange)="onReferenceSelected(ReferenceSegment.selectedOptions.selected)" formControlName="referenceCriteria">
              <mat-list-option *ngFor="let referenceCode of referenceCodes" [value]="referenceCode.value"
                checkboxPosition="before" id="{{referenceCode.value}}" style="font-size: inherit;">
                {{referenceCode.displayText}}
              </mat-list-option>
            </mat-selection-list>
          </mat-card>
        </mat-expansion-panel>

    </div>
    <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between space-between" class="button-container">
      <button mat-button class="tcb-button" type="submit" (click)="applyFilter()">
        Apply
      </button>
      <button mat-stroked-button type="button" (click)="onClear()">
        Clear
      </button>
    </div>
  </div>
</form>
  </mat-accordion>
</ng-template>
</div>

